const moduleUserSession = {
    namespaced: true,
    state: {
        user: {
            userName: "",
            rut: "",
            email: "",
            users_roles: [],
            role_id: "",
        },
    },
    getters: {
        getUser(state) {
            return state.user;
        },
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
    },
};
export default moduleUserSession;
